import React from "react";
import { IS_HIDDEN_ENV } from "./utils";

export const BetaFeature: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => <>{IS_HIDDEN_ENV ? null : children}</>;
